
export enum WorkflowMode {
  VIEW = 'view',
  NEW = 'new',
  EDIT = 'edit'
}
